import { HttpTypes } from "@medusajs/types"

/** Extract size label from a variant's options array. */
export function getSizeFromVariant(
  variant: HttpTypes.StoreProductVariant
): string {
  if (!variant.options?.length) return variant.title || ""
  const sizeOpt = variant.options.find(
    (o) => o.option?.title?.toLowerCase() === "size"
  )
  return sizeOpt?.value || variant.options[0]?.value || variant.title || ""
}
